// extracted by mini-css-extract-plugin
export default {"wrapper":"HorizontalScroll_wrapper__4Ly8j","progress":"HorizontalScroll_progress__jq2h-"};